var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroSquiggle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 310,
    height: 220,
    viewBox: "0 0 310 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.59326 28.9647C1.59326 44.5837 2.55508 57.6263 11.7911 70.9774C24.3732 89.1653 43.9016 110.283 65.8335 116.776C96.2869 125.792 133.596 121.265 163.965 114.456C186.613 109.378 207.083 101.55 225.946 88.1366C238.497 79.2113 250.404 68.8903 257.699 55.1005C262.885 45.2986 269.7 31.1365 264.905 20.0493C254.384 -4.28019 220.218 -1.2741 202.253 12.3551C187.11 23.8427 174.994 41.8925 166.468 58.5812C155.289 80.4641 141.79 110.851 147.05 136.195C150.756 154.053 165.514 167.074 182.529 172.101C196.607 176.26 211.486 175.899 226.007 176.314C242.291 176.78 258.561 177.657 274.798 179.001C282.164 179.611 300.352 180.605 301.605 191.886C302.576 200.628 302.765 209.208 302.765 218.022",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M296.926 211.513C297.784 212.371 303.764 219.677 304.697 217.916C305.791 215.848 305.808 212.736 308.254 211.513",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroSquiggle);
export default __webpack_public_path__ + "static/media/hero-squiggle.ac312937e2112551e10cd64008407cd5.svg";
export { ForwardRef as ReactComponent };